// Display helpers

// Convert ISO date 'YYYY-MM-DD' (or '' / undefined) to 'DD/MM/YYYY' for display.
export const formatDateDMY = (iso) => {
  if (!iso || typeof iso !== "string") return "";
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return iso;
  const [, y, mo, d] = m;
  return `${d}/${mo}/${y}`;
};

// Convert a Date object to ISO 'YYYY-MM-DD' (local time, no timezone shift).
export const dateToISO = (date) => {
  if (!date || !(date instanceof Date) || isNaN(date)) return "";
  const y = date.getFullYear();
  const mo = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${mo}-${d}`;
};

// Parse ISO 'YYYY-MM-DD' to a Date (local) — returns undefined if invalid.
export const isoToDate = (iso) => {
  if (!iso || typeof iso !== "string") return undefined;
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return undefined;
  const [, y, mo, d] = m;
  return new Date(Number(y), Number(mo) - 1, Number(d));
};
